import {
  MailOutlined,
  MedicineBoxOutlined,
  MessageOutlined,
  PhoneOutlined,
  SendOutlined
} from '@ant-design/icons';
import { Button, Col, Divider, Input, Layout, Row, Space, Typography } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n';

const { Footer: AntFooter } = Layout;
const { Title, Text, Paragraph } = Typography;

const Footer: React.FC = () => {
  const { t } = useI18n();

  return (
    <AntFooter style={{
      background: '#f5f5f5',
      padding: '48px 0 24px',
      color: '#333',
      margin: 0,
      borderTop: '1px solid #e8e8e8'
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px' }}>
        <Row gutter={[24, 48]}>
          {/* 公司信息 */}
          <Col xs={24} sm={12} md={6}>
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
              <Space>
                <MedicineBoxOutlined style={{ fontSize: '24px', color: '#17a2b8' }} />
                <Title level={4} style={{ color: '#333', margin: 0, fontWeight: 700 }}>
                  {t('footer.company.name')}
                </Title>
              </Space>
              <Paragraph style={{ color: '#666', margin: 0, lineHeight: '1.8' }}>
                {t('footer.company.description')}
              </Paragraph>
            </Space>
          </Col>

          {/* 快速链接 */}
          <Col xs={24} sm={12} md={6}>
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
              <Title level={5} style={{ color: '#333', margin: 0, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                {t('footer.quickLinks.title')}
              </Title>
              <Space direction="vertical" size="small" style={{ width: '100%' }}>
                <Link to="/products" style={{ color: '#666', transition: 'color 0.3s' }} className="footer-link">
                  {t('footer.quickLinks.features')}
                </Link>
                <Link to="/symptoms" style={{ color: '#666', transition: 'color 0.3s' }} className="footer-link">
                  {t('footer.quickLinks.symptoms')}
                </Link>
                <Link to="/saline-guide" style={{ color: '#666', transition: 'color 0.3s' }} className="footer-link">
                  {t('footer.quickLinks.saline')}
                </Link>
                <a href="#" style={{ color: '#666', transition: 'color 0.3s' }} className="footer-link">
                  {t('footer.quickLinks.vortex')}
                </a>
              </Space>
            </Space>
          </Col>

          {/* 服务 */}
          <Col xs={24} sm={12} md={6}>
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
              <Title level={5} style={{ color: '#333', margin: 0, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                {t('footer.services.title')}
              </Title>
              <Space direction="vertical" size="small" style={{ width: '100%' }}>
                <Link to="/about" style={{ color: '#666', transition: 'color 0.3s' }} className="footer-link">
                  {t('footer.services.cooperation')}
                </Link>
                <Link to="/about" style={{ color: '#666', transition: 'color 0.3s' }} className="footer-link">
                  {t('footer.services.about')}
                </Link>
                <a href="#" style={{ color: '#666', transition: 'color 0.3s' }} className="footer-link">
                  {t('footer.services.contact')}
                </a>
              </Space>
            </Space>
          </Col>

          {/* 联系信息 */}
          <Col xs={24} sm={12} md={6}>
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
              <Title level={5} style={{ color: '#333', margin: 0, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                {t('footer.contact.title')}
              </Title>
              <Space direction="vertical" size="small" style={{ width: '100%' }}>
                <Space>
                  <MailOutlined style={{ color: '#17a2b8' }} />
                  <Text style={{ color: '#666' }}>
                    {t('footer.contact.email')}
                  </Text>
                </Space>
                <Space>
                  <PhoneOutlined style={{ color: '#17a2b8' }} />
                  <Text style={{ color: '#666' }}>
                    {t('footer.contact.phone')}
                  </Text>
                </Space>
                <Space>
                  <MessageOutlined style={{ color: '#17a2b8' }} />
                  <Text style={{ color: '#666' }}>
                    {t('footer.contact.line')}
                  </Text>
                </Space>
              </Space>

              {/* 邮件订阅 */}
              <Space.Compact style={{ width: '100%', marginTop: '8px' }}>
                <Input
                  placeholder={t('footer.newsletter.placeholder')}
                  style={{
                    background: 'white',
                    border: '1px solid #d9d9d9',
                    color: '#333'
                  }}
                />
                <Button
                  type="primary"
                  icon={<SendOutlined />}
                  style={{ background: '#17a2b8', border: 'none' }}
                />
              </Space.Compact>
            </Space>
          </Col>
        </Row>

        <Divider style={{ borderColor: '#e8e8e8', margin: '32px 0 24px' }} />

        <Row justify="space-between" align="middle">
          <Col xs={24} sm={12} style={{ textAlign: 'center', marginBottom: '12px' }}>
            <Text style={{ color: '#666' }}>
              {t('footer.legal.copyright')}
            </Text>
          </Col>
          <Col xs={24} sm={12} style={{ textAlign: 'center' }}>
            <Space wrap>
              <Link to="/privacy-policy" style={{ color: '#666' }} className="footer-link">
                {t('footer.legal.privacy')}
              </Link>
              <Link to="/delete-account" style={{ color: '#666' }} className="footer-link">
                {t('footer.legal.deleteAccount')}
              </Link>
              <a href="#" style={{ color: '#666' }} className="footer-link">
                {t('footer.legal.terms')}
              </a>
              <a href="#" style={{ color: '#666' }} className="footer-link">
                {t('footer.legal.sitemap')}
              </a>
            </Space>
          </Col>
        </Row>
      </div>

      {/* 添加footer链接悬停样式 */}
      <style>{`
        .footer-link:hover {
          color: #17a2b8 !important;
        }
        
        @media (max-width: 576px) {
          .ant-col.ant-col-xs-24.ant-col-sm-12:last-child {
            text-align: center !important;
            margin-top: 12px;
          }
        }
      `}</style>
    </AntFooter>
  );
};

export default Footer;
